<template>
    <div>
		<!-- main data table for displaying all of the historical actuals and forecast qtys -->
        <v-data-table
        :headers="headers"
        :items="filteredTable"
        item-key="Style Code"
        :search="search"
        :sort-by="['Product Name', 'Style Code']"
        :sort-desc="[false, true]"
        multi-sort
		:loading="loading"
		loading-text="Loading"
		no-data-text="Please Select Forecast Category and/or Year"
        class="elevation-1"
        fixed-header
		height="65vh"
        width="80vh"
		>
			<!-- search field on top -->
			<template v-slot:top>
				<v-text-field
				v-model="search"
				label="Search"
				class="mx-4"
				></v-text-field>
			</template>
			<!-- body of everything -->
			<template v-slot:item="{ item }">
				<!-- define the row template for all rows to be based on for all :items in the data table -->
				<!-- make the text color of the row different if the product is NOT active -->
				<tr :style="{color: rowColor(item['Active'])}">
					<!-- first few columns are just product information -->
					<td>{{ item["Product Name"] }} {{ item["Option 1"] }}</td>
					<td>{{ item["Style Code"] }}</td>
					<td>{{ item["Price"] | currency }}</td>
					<td>{{ item["Cost"] | currency }}</td>
					<!--This lists through the first 6 months-->
					<template v-for="(month, index) in firstHalf">
						<!-- I understand this should be a custom component that information is passed into
							but, that would require passing the entire 'actualQtys' object into the component
							which I am not sure would be more efficient. As a simplier solution I just call a
							method that returns raw HTML to be modeled into the v-html of the table data-->
						<!-- this is the actual column that shows 3 years of historcials and growth over those years -->
						<td :key="index + 'H'"
							v-html="returnActuals(month, item['Style Code'], showPreOrders)">
						</td>
						<!-- this is the forecast column that users interact with in order to input their forecast -->
						<!-- the class is to determine if there should be a pointer cursor or a regular one -->
						<!-- clicking on the cell will open it normally (dialog) or right clicking will open speed round
							SMALL BUG: if you scroll horizontally and try to right click, the browser has lost track of 
							the mouse position and will not work because the default right click action cannot be blocked -->
						<td 
							:class="clickableItem(item.Active)"
							style="text-align:center;vertical-align:middle;"
							:key="index + 'F'"
							@click="open(item, month, false, $event)"
							@contextmenu="open(item, month, true, $event)"
							v-html="returnForecast(month,item['Style Code'], showPreOrders)"> 
						</td>
					</template>
					<!-- Half Year actual Totals -->
					<td 
						style="background-color:#7030A0; color:#FFFFFF"
						v-html="skuTotals(item['Style Code'], showPreOrders, firstHalf)"
					/>
					<!-- half year forecast totals -->
					<td 
						style="background-color:#7046A0; 
						color:#FFFFFF 
						text-align:center;
						vertical-align:middle;" 
						v-html="forecastSKUTotals(item['Style Code'], showPreOrders, firstHalf)"
					/>
					<!-- lists through the second 6 months -->
					<template v-for="(month,index) in secondHalf">
						<!-- the same thing as above, just for the second 6 months as there was a feature request
							to have half year totals. I know there is probably a more eligant solution to this, but
							this was the fastest solution I could think of: split up the columns into two for loops
							separated by the totals columns -->
						<td :key="index + '2H'"
						v-html="returnActuals(month, item['Style Code'], showPreOrders)"/>
						<td
							:class="clickableItem(item.Active)"
							style="text-align:center;vertical-align:middle;"
							:key="index + '2F'"
							@click="open(item, month)" 
							v-html="returnForecast(month,item['Style Code'], showPreOrders)"> 
						</td>
					</template>
					<!-- second half actual totals -->
					<td style="background-color:#7030A0;color:#FFFFFF" 
						v-html="skuTotals(item['Style Code'], showPreOrders, secondHalf)"/>
					<!-- second half forecast totals -->
					<td style="background-color:#7046A0;color:#FFFFFF;text-align:center;vertical-align:middle;" 
						v-html="forecastSKUTotals(item['Style Code'], showPreOrders, secondHalf)"/>
					<!-- total year actual totals -->
					<td style="background-color:#7030A0; color:#FFFFFF" 
						v-html="skuTotals(item['Style Code'], showPreOrders, allMonths)"/>
					<!-- total year forecast totals -->
					<td style="background-color:#7046A0;color:#FFFFFF;text-align:center;vertical-align:middle;" 
						v-html="forecastSKUTotals(item['Style Code'], showPreOrders, allMonths)"/>
				</tr>
			</template>
			<!-- total row at the bottom -->
			<template v-slot:[`body.append`]="{headers}">
				<!-- make the one total row. SMALL BUG: if you refresh the page the row will come back to 
					sticky even if the setting is disabled untill you click on settings again -->
				<tr :class="showTotalRow" :key="showTotalRow">
					<!-- list through all headers and use the key value pair Months to determine what should be totaled -->
					<td v-for="(header,index) in headers"
					:key="index + 'Total'"
					v-html="returnMonthTotals(header,showPreOrders)"/>
				</tr>
			</template>
		</v-data-table>
		<!-- the information bar that pops up for every action taken -->
        <v-snackbar
			v-model="snackbar"
			:timeout="timeout"
			:color="snackColor">
			<!-- the text to display during the notification -->
			<template v-if="!loading">
				{{ snackText}}
			</template>
			<!-- I implimented a loading aspect to it, but when it is 'loading' its a chunky boy and looks a little weird
				I have started to move to other loading elements, like the table loading bar or conditionally loading 
				the progress-circiluar and adding the indeterminate prop to it -->
			<template v-if="loading">
				<v-text-field
					color="white"
					:loading="loading"
				></v-text-field>
			</template>
			<!-- dismiss button -->
			<template v-slot:action="{ attrs }">
				<v-btn
					v-bind="attrs"
					text
					@click="snackbar = false"
				>
					Close
				</v-btn>
			</template>
		</v-snackbar>
		<!-- simple product modal for when speed round is enabled in the settings--> 
		<!-- the menu allows it to popup in any x,y coordinate which can allow it to pop up 
			whereever the mouse is SMALL BUG: with horizontal scrolling -->
		<v-menu
			v-model="modalState.simple"
			:close-on-content-click="false"
			:position-x="x"
			:position-y="y"
			absolute
			offset-x>
			<v-card>
				<!-- display the month for the title of the small popup -->
				<v-card-title>{{ selected.monthSelect }}</v-card-title>
				<v-card-text>
					<!-- the input for the qty. All units are assumed to be ASAP Normal units -->
					<v-text-field
						v-model="qty.input"
						label="Edit"
						single-line
						dense
						type="Number"
						:min="qty.minimum"
						@input="simpleForecastChange()"
						@focus="$event.target.select()"
						autofocus>
					</v-text-field>
				</v-card-text>
				<!-- close and submit buttons -->
				<v-card-actions class="d-flex justify-space-between align-center">
					<!-- close button -->
					<v-btn
						color="primary"
						@click="closeSimpleModal()">
					Cancel
					</v-btn>
					<!-- submit button -->
					<v-btn
						color="primary"
						@click="save(true); closeSimpleModal()">
					Submit
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-menu>
		<!-- product forecast modal -->
		<v-dialog 
			v-model="modalState.product"
			height="50vh"
			width="50vw"
			transition="dialog-bottom-transition"
			persistent
			:hide-overlay="true"
			overlay-opacity="0">
			<v-card class="pt-3 px-5 pb-5">
				<!-- lists the month and product name -->
				<v-card-title class="justify-center px-1 pt-1 pb-0 mb-1">{{ category.Forecast_Name }} </v-card-title>
				<v-card-title class="pt-0 px-1 mt-0 pr=0">
					<!-- Column for the month selector -->
					<v-col cols="2" class="pl-0">
						<v-select
							class="shrink"
							hide-details
							v-model="selected.monthSelect"
							@change="monthChange()"
							:items="monthNames"
							solo
						></v-select>
					</v-col>
					<!-- Column for the product selector -->
					<v-col cols="10" class="pr-0">
						<v-autocomplete
							class="shrink"
							hide-details
							v-model="selected.productSelect"
							@change="productChange()"
							:items="activeProductNames"
							solo
						></v-autocomplete>
					</v-col>
				</v-card-title>
				<v-divider horizontal></v-divider>
				<template>
					<!-- Div tag allows the chart to be capped at a certain height -->
					<div class="chartArea">
						<!-- passing into the chart the refresh token for when the chart 
							needs to be refreshed along with the dataset data. The explain 
							prop tells the product chart whether or not to make an API call 
							to get the companies responsible for the qtys sold (category, 
							sku, and sku2 are other props that assists in this API call) sku2
							is the compare product and the year is the year that should be charted
							of that comparision sku-->
					<productChart 
						class="productChart"
						v-model="chartLoading"
						:height="200"
						elevation="2"
						:chartData="chart.data" 
						:refresh="chart.refresh" 
						:explain="chart.explain"
						:category="category.Forecast_Name"
						:year="year"
						:sku="selected.product['Style Code']"
						:sku2="selected.compare.sku"/>
					</div>
				</template>
				<v-spacer></v-spacer>
				<template>
					<!-- this row is all of the chart components that are passed into the chart
						as props -->
					<v-row class="d-flex justify-center align-center">
						<!-- column for the explain toggle that renders the companies that purchased the skus -->
						<v-col class="pb-0 pt-0 mt-0">
							<v-switch
								class="mt-0"
								label="Explain Chart"
								hide-details
								v-model="chart.explain"/>
						</v-col>
						<!-- the year selector allows any year to be charted for the comparision product -->
						<v-col class="pb-0">
							<v-select
								class="shrink"
								:items="getYears"
								hide-details
								v-model="selected.compare.year"
								@change="toggleProductInChart()"
								label="Compare Year"
								dense
							></v-select>
						</v-col>
						<!-- this selector allows the user to super impose any product over the existing product -->
						<v-col class="pb-0">
							<v-autocomplete
								label="Add Product to Compare"
								class="shrink"
								hide-details
								v-model="selected.compare.product"
								:items="compareProducts"
								@change="toggleProductInChart()"
								dense>
							</v-autocomplete>
						</v-col>
					</v-row>
				</template>
				<!-- this is the row for actual forecasting information inputs -->
				<v-row>
					<!-- this card/column is displaying the actual qty for the sku and month selected -->
					<v-col md="auto">
						<v-card height="100%" width="125px">
							<v-card-title :style="dialogTitle" class="py-2 justify-center align-center">{{ selected.monthSelect }} Actual</v-card-title>
							<v-card-text class="pb-0 d-flex justify-center align-center">
								{{ returnMonthActuals }}
							</v-card-text>
							<v-card-title :style="dialogTitle" class="py-0 justify-center align-center">
								Price
							</v-card-title>
							<v-card-text class="py-0 d-flex justify-cetner align-center">
								<!-- allows for the user to edit the price of the item -->
								<v-text-field
									prefix="$"
									class="centered-input"
									v-model="selected.product.Price"
									label="Product Price"
									single-line
									hide-details
									dense
									number
									min="0"/>
							</v-card-text>
						</v-card>
					</v-col>
					<!-- input for the forecast, also displaying the total $$ the units calculate into -->
					<v-col>
						<v-card height="100%">
							<v-card-title :style="dialogTitle" class="justify-center pt-2 mb-1 pb-1">Input Forecast - {{ lineTotal | currency }}</v-card-title>
							<v-card-text class="justify-center">
								<v-text-field
									class="centered-input"
									v-model="qty.input"
									@focus="selected.focus = true"
									@blur="selected.focus = false"
									@input="updateForecast(false)"
									label="Forecast Qty"
									hide-details
									single-line
									dense
									type="Number"
									:min="qty.minimum"></v-text-field>
							</v-card-text>
						</v-card>
					</v-col>
					<!-- only render this column if biz dev is applicable computed property 'BizDevMonth' -->
					<v-col v-if="BizDevMonth">
						<!-- uses the information from the settings dialog (componenets/Home/bizDevInput.vue)
							to calculate the avg per door and roll that into the total forecast-->
						<v-card height="100%">
							<v-card-title style="font-size: 16px" class="pb-0 justify-center">Growth with {{ doors.prediction }} New Doors</v-card-title>
							<!-- Show one thing if the biz dev qty has not been submited yet -->
							<v-card-text v-if="!isThereAlreadyBizDevQty" class="pb-0 d-flex text-center justify-center align-center">
								With {{ bizDev.newDoors }} new doors and an average 
								of {{bizDev.averagePerDoor }} units per door in 
								{{ year - 1 }} will result in {{ qty.bizDev }} Biz Dev units for this half
							</v-card-text>
							<!-- show this if the biz dev qty has been submited -->
							<v-card-text v-else class="pb-0 d-flex text-center justify-center align-center">
								Note: This has already been submited with a Biz Dev Qty of {{ qty.bizDev }}. 
								The suggested qty was {{ Math.round(Number(bizDev.newDoors) * Number(bizDev.averagePerDoor)) }}
							</v-card-text>
							<!-- allows you to override the precalculated bizDev qty incase it wouldn't make sense
								(discontinued product or something) -->
							<v-text-field
								class="mx-5 centered-input"
								v-model="qty.bizDev"
								@input="updateForecast(true)"
								hide-details
								single-line
								width="50%"
								dense
								type="Number"
								min="0"></v-text-field> 
						</v-card>
					</v-col>
					<!-- only render this column if biz dev is applicable computed property 'BizDevMonth' -->
					<v-col v-if="BizDevMonth">
						<!-- display the total forecast qty (input qty + biz dev qty) and the total dollar amount -->
						<v-card height="100%">
							<v-card-title style="font-size: 16px" class="justify-center">Total Forecast</v-card-title>
							<v-card-text>
								<v-row justify="center">
									<!-- total qty -->
									<v-col class="d-flex justify-center align-center">
										{{ qty.total }} 
									</v-col>
									<v-divider vertical></v-divider>
									<!-- total dollar amount -->
									<v-col class="d-flex justify-center align-center">
										{{ lineTotal | currency }}
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
				<!-- only render if the selected forecast category is preorder eligible and the input is greater than 1-->
				<v-row v-if="category.Preorder == 1 && qty.input > 0">
					<v-col cols="2" class="pr-2">
						<v-card height="100%">
							<v-card-title  style="font-size: 14px" class="pt-1 mb-0 pb-0 justify-center align-center text-center">
								Pre-Order
							</v-card-title>
							<v-card-title  style="font-size: 14px" class="py-0 my-0 justify-center align-center text-center">
								Discount
							</v-card-title>
							<v-card-text class="my-0 py-0">
								<v-text-field
									class="my-0 py-0 centered-input"
									suffix="%"
									hide-details
									v-model="preorderDiscount"/>
							</v-card-text>
							<v-card-text 
								v-html="preorderDiscountMessage" 
								style="font-size: 9px" 
								class="my-0 py-0 px-0 mx-0 text-center"/>
						</v-card>
					</v-col>
					<!-- slider for allocating ASAP vs Preorder -->
					<v-col cols="10" class="pl-4">
						<v-card height="100%">
							<v-card-text class="pr-0 pl-0">
								<v-row>
									<!-- column for the preorder vs asap attribution slider -->
									<v-col cols="2" class="d-flex justify-center text-center">
										<div>
										<v-text-field
											class="centered-input"
											v-model="qty.preorder"
											dense
											hide-details
											type="Number"
											:min="sliderMinimum"
											:max="qty.total"></v-text-field>
										{{ preorderTotal | currency }}<br>
										Pre-Order <br>
										{{ percentPreorder }}%
										</div>
									</v-col>
									<!-- slider -->
									<v-col cols="8" class="d-flex justify-center align-center">
										<v-slider
											v-model="qty.preorder"
											track-color="blue"
											thumb-color="black"
											hide-details
											:min="sliderMinimum"
											:max="qty.total"
											step="1"
										></v-slider>
									</v-col>
									<!-- ASAP information (all of ASAP is computed and cannot be changed directly
										only by editing preorder is ASAP computed to be the remainder of the total) -->
									<v-col cols="2" class="d-flex justify-center align-center text-center">
										{{ qty.asap }}<br>
										{{ asapTotal | currency }}<br>
										ASAP<br>
										{{ percentASAP }}%
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
				<!-- Notes field -->
				<v-row class="pt-3">
					<v-text-field
						solo
						v-model="selected.product.Notes"
						label="Notes"
					></v-text-field>
				</v-row>
				<v-spacer></v-spacer>
				<!-- viewing previous years notes of the sku on the selected month  -->
				<v-row class="pb-3">
					<v-expansion-panels>
						<v-expansion-panel>
							<v-expansion-panel-header>
								Previous Notes
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row>
									<!-- go back three years of notes not sure if 'n' here is the index or the increment...
										it works so I am leaving it... SMALL BUG -->
									<v-col v-for="(index, n) in 3" :key="n">
										<v-card>
											<v-card-title primary-title class="justify-center">{{ year - n }}</v-card-title>
											<v-card-text>{{ productNotes[2 - n] }}</v-card-text>
										</v-card>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-row>
				<!-- buttons for closing or submitting -->
				<v-row justify="space-between">
					<!-- close button -->
					<v-btn 
						color="primary"
						@click="modalState.product = false">
						<v-icon>mdi-close-circle</v-icon>Cancel
					</v-btn>
					<v-spacer></v-spacer>
					<!-- submit button -->
					<v-btn 
						color="primary"
						@click="save(true)">
						<v-icon>mdi-checkbox-marked-circle</v-icon>Submit
					</v-btn>
				</v-row>
			</v-card>
		</v-dialog>
		<!-- Warning Dialog -->
		<warning :warning="warning" v-model="warning.dialog"/>
    </div>
</template>

<style src="@/stylesheet.css" scoped></style>

<script>
import productChart from "@/components/Home/productChart.vue"
import warning from "@/components/General/warning.vue"

const fetch = require('node-fetch');
const formatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD'
})
export default {
	name: 'ForecastTable',
	components: {
		productChart,
		warning,
	},
	created() {
		window.addEventListener('keydown', (e) => {
			if (this.modalState.product) {
				if (e.key == 'ArrowRight' && this.selected.month != 12 && !this.selected.focus) {
					this.monthChange(1);
					if (this.BizDevMonth) {
						this.BizDevInformation()
					}
				} else if(e.key == 'ArrowLeft' && this.selected.month != 1 && !this.selected.focus) {
					this.monthChange(-1)
					if (this.BizDevMonth) {
						this.BizDevInformation()
					}
				// } else if (e.key == 'ArrowUp' && this.productNames.indexOf(this.selected.product['Product Name']) != 0) {
				// 	this.productChange(1)
				// } else if (e.key == 'ArrowDown' && this.productNames.indexOf(this.selected.product['Product Name']) != this.productNames.length) {
				// 	this.productChange(-1)
				} else if( e.key == 'Escape') {
					this.modalState.product = false;
					this.modalState.simple = false
				}
			} else if (this.modalState.simple || this.modalState.product) {
				if (e.key == "Enter") {
					this.save(true)
				}
			}
		});
	},
	beforeMount() {
		this.getProducts();
		this.qty.bizDev = 0
		this.chart.data.labels = this.monthNames;
	},
	props: {
		year: {type: Number},
		category: {type: Object},
		checkForecastInfo: {type: Object},
		refresh: {type: Number},
	},
	watch: {
		year: function(newValue) {
			if (this.$props.category.Forecast_Name != "None Selected") {
				this.getProducts()
				this.getForecastDetails(newValue, this.$props.category.Forecast_Name);
			}
		},
		'category.Forecast_Name': function() {
			if (this.$props.year && this.$props.category.Forecast_Name != "None Selected") {
				this.getProducts()
				this.getForecastDetails(this.$props.year, this.$props.category.Forecast_Name);
			}
		},
		refresh: function() {
			if (this.$props.year && this.$props.category.Forecast_Name != "None Selected") {
				this.getForecastDetails(this.$props.year, this.$props.category.Forecast_Name);
			}
		},
		'checkForecastInfo.product': function() {
			this.open(this.checkForecastInfo.product, this.checkForecastInfo.month)
		},
		'checkForecastInfo.refresh': function() {
			this.open(this.checkForecastInfo.product, this.checkForecastInfo.month)
		},
		chartLoading: function() {
			if (this.chartLoading) {
				this.snack('','primary',true)
			} else {
				this.snack('Complete','success',false)
			}
		}
	},
	data() {
		return {
			currentNote: '',
			x: 0,
			y: 0,
			export: {
				forecastQtys: [],
				products: [],
				goal: {
					part: 0,
					whole: 0,
				},
				preorderReset: 0,
			},
			doors: {
				firstHalfPrediction: 0,
				secondHalfPrediction: 0,
			},
			actualQtys: [],
			monthTotals: [],
			modalState: {
				product: false,
				simple: false,
			},
			preorderDiscount: 0,
			preorderDiscountMessage: '',
			selected: {
				product: {},
				compare: {
					product: 'None Selected',
					sku: '',
					year: 2021,
				},
				month: 0,
				monthSelect: '',
				productSelect: '',
				price: 'Price',
				cost: 'Cost',
				goal: 0,
				focus: false,
			},
			qty: {
				total: 0,
				input: 0,
				preorder: 0,
				asap: 0,
				bizDev: 0,
				minimum: 0,
			},
			search: '',
			products: [],
			monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
			forecastQtys: [],
			forecastProducts: [],
			costPriceList: [],
			productNotes:['','',''],
			notes: [],
			bizDev: {
				newDoors: 0,
				averagePerDoor: 0,
				totalBizDevQty: 0,
			},
			chart: {
				data:{
					label: "Overview",
					labels: [],
					datasets: []
				},
				years: [0,1,2,3],
				explain: 0,
				refresh: '0',
			},
			doorsCalculated: {
				historicUnitsPerDoor: 0,
				totalUnitsForNewDoors: 0,
				totalUnitsForAllDoors: 0
			},
			firstHalf: [1,2,3,4,5,6],
			secondHalf: [7,8,9,10,11,12],
			allMonths: [1,2,3,4,5,6,7,8,9,10,11,12],
			chartLoading: false,
			loading: false,
			snackbar: false,
			snackColor: '',
			snackText: '',
			timeout: 3000,
			warning: {
				dialog: false,
				message: '',
				directory: {
					path: '',
					icon: '',
					message: '',
				}
			}
		}
	},
	methods: {
		getForecastDetails(year, category) {
			// https://us-east-2.console.aws.amazon.com/lambda/home?region=us-east-2#/functions/Forecast_getForecastDetails?tab=code
			// calls the above lambda function to get all the information about the selected category
			const url = 'https://ww62v3jt5m.execute-api.us-east-2.amazonaws.com/prod/forecastdetails';
			const data = {
				'year': year,
				'category': category,
			};
			const request = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(data),
			};
			this.loading = true
			fetch(url, request).then( async response => {
				//error handling
				const data = await response.json();
				if (!response.ok) {
					const error = (data && data.message) || response.status
					return Promise.reject(error)
				}
				//check to make sure all data is there, 
				//if not, prompt warning screen with suggestion on how to fix it
				this.warning.dialog = false
				if (data.costPriceList.length == 0 && 
					data.costName.length == 0 &&
					data.priceName.length == 0 &&
					data.forecastQtys.length == 0 &&
					data.actualQtys.length == 0 &&
					data.monthTotals.length == 0 &&
					data.notes.length == 0) {
						this.warning.dialog = true
						this.warning.message = "This category has no accounts assigned to it. " +
							"Please following the link below to assign an account to the '" +
							this.$props.category.Forecast_Name + "' category"
						this.warning.directory.path = "/accounts"
						this.warning.directory.icon = "mdi-account-box"
						this.warning.directory.message = "Assign Lists"
						return Promise.reject(error)
				} else {
					this.warning.dialog = false
					this.warning.message = ''
					this.warning.directory.path = ''
					this.warning.directory.icon = ''
					this.warning.directory.message = ''
				}

				//move all data variables to local variables
				this.actualQtys = data.actualQtys
				this.monthTotals = data.monthTotals
				this.forecastQtys = data.forecastQtys
				this.forecastProducts = data.forecastProducts
				this.costPriceList = data.costPriceList
				this.selected.price = data.priceName[0].Name
				this.selected.cost = data.costName[0].Name
				if (data.goal.length > 0) {
					this.selected.goal = data.goal[0].Goal
				} else {
					this.selected.goal = 0
				}
				this.notes = data.notes
				let costPriceList = data.costPriceList

				//establishes doors count and sets to zero if the prediction doesnt exist yet
				//im sure there is a better way to write this
				let firstHalf = 0
				let secondHalf = 0
				if (data.doorPrediction.length == 0) {
					firstHalf = 0
					secondHalf = 0
				} else {
					firstHalf = data.doorPrediction[0].First_Half
					secondHalf = data.doorPrediction[0].Second_Half
				}

				this.doors = {
					current: data.doorCount[0].doorCount,
					firstHalfPrediction: firstHalf,
					secondHalfPrediction: secondHalf,
					total: data.doorCount[0].doorCount
				}
				//establish items that need to exported to other components outside of the forecastTable.vue
				this.export.forecastQtys = data.forecastQtys
				this.export.goal.whole = this.selected.goal
				this.export.goal.part = this.forecastQtys.reduce(function(sum, record){ return sum + record.Total },0)
				this.export.preorderReset += 1
				this.$emit('input', this.export);

				//list through the cost/price list and append all products with their cost/price
				for (let i = 0; i < costPriceList.length; i++) {
					let cost =''
					let price = ''
					if (costPriceList[i].Cost === null) {
						cost = 0
					} else {
						cost = costPriceList[i].Cost
					}
					if (costPriceList[i].Price === null) {
						price = 0
					} else {
						price = costPriceList[i].Price
					}
					let sku = this.products.find(item => item['Style Code'] === costPriceList[i]['Style Code'])
					if (sku) {
						sku.Cost = cost
						sku.Price = price
					}
				}
				this.snack('Complete','success',false)
			})
			.catch(error => {
				if (!this.warning.dialog) {
					this.snack('Loading Forecast: ' + error,'error',false)
				}
			})
		},
		getProducts() {
			//https://us-east-2.console.aws.amazon.com/lambda/home?region=us-east-2#/functions/getProducts?tab=code
			//gets all products within the active product categories using the above lambda function 
			const url = 'https://ww62v3jt5m.execute-api.us-east-2.amazonaws.com/prod/products';
			const request = {
				method: 'GET',
				Headers: {
					'Content-Type': 'application/json',
				},
			};
			this.loading = true
			fetch(url, request).then(async response => {
				const productLists = await response.json();

				if (!response.ok) {
					const error = (data && data.message) || response.status
					return Promise.reject(error)
				}
				this.products = productLists
				this.export.products = productLists
				this.$emit('input', this.export);

				this.snack('Complete','success',false)
			})
			.catch(error => {
				this.snack(error,'error',false)
			})
		},
		save(close) {
			//sets all qtys to 0 if the input is left blank
			if (this.qty.input ='') {
				this.qty.input = 0
				this.qty.total = 0
				this.qty.asap = 0
			}
			//https://us-east-2.console.aws.amazon.com/lambda/home?region=us-east-2#/functions/Forecast_UpdateForecast?tab=code
			//makes request to AWS is update or create forecast at the above lambda function
			const url = 'https://ww62v3jt5m.execute-api.us-east-2.amazonaws.com/prod/forecastdetails';
			const data = {
				username: localStorage.username,
				sku: this.selected.product['Style Code'],
				month: Number(this.selected.month),
				qty: {
					asap: this.qty.asap,
					preorderBizDev: this.qty.bizDev,
					preorderNormal: (this.qty.preorder - this.qty.bizDev)
				},
				total: {
					asap: this.asapTotal,
					preorderBizDev: this.preorderBizDevTotal.toFixed(2),
					preorderNormal: this.preorderNormalTotal.toFixed(2)
				},
				discount: {
					asap: 0,
					preorderBizDev: this.preorderBizDevDiscountTotal.toFixed(2),
					preorderNormal: this.preorderNormalDiscountTotal.toFixed(2)
				},
				category: this.$props.category.Forecast_Name,
				year: this.$props.year,
				discountPercent: this.preorderDiscount / 100 || 0,
				notes: this.selected.product.Notes,
				price: this.selected.product.Price,
				cost: this.selected.product.Cost,
			};
			const request = {
				method: 'PUT',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(data),
			};
			
			this.snack('Submited','info',false)
			if (this.otherSettings.hideModalAfterSubmit == true && close) {
				this.modalState.product = false
				this.modalState.simple = false
			}

			fetch(url, request).then(async response => {
				const data = await response.json();

				if (!response.ok) {
					const error = (data && data.message) || response.status
					return Promise.reject(error)
				}

				//gets the updated forecastQtys after the submittion
				this.forecastQtys = data.updatedForecast;
				//sets the export prop with the new data
				this.export.forecastQtys = this.forecastQtys
				//updates the goal for the pie graph in the upper right
				this.export.goal.part = this.forecastQtys.reduce(function(sum,record) { return sum + record.Total },0)
				//updates the notes array object
				this.notes = data.updatedNotes

				this.$emit('input', this.export)
				this.snack('Data Saved', 'success', false)
			})
			.catch(error => {
				this.snack(error,'error',false)
			})
		},
		cancel() {
			this.snack('Canceled','info',false)
			this.preorderDetails = this.$store.getters.getPreorder
		},
		closeSimpleModal() {
			this.modalState.simple = false
		},
		open(item, month, simpleModal, e) {
			//resets the compare product
			this.selected.compare.product = 'None Selected'
			//resets the compare year
			this.selected.compare.year = this.$props.year - 1
			//checks if category is selected, if not then snack
			if (this.$props.category.Forecast_Name === "None Selected") {
				this.snack('Select Forecast Category First','info',false)
			//makes sure the selected item is not active
			} else if (item.Active == 0) {
				this.snack('Select Active Product', 'info', false)
			//makes sure the product has a price
			} else if (!item.hasOwnProperty('Price')) {
				this.snack('This product has no price', 'error', false)
			//makes sure the product has a cost
			} else if (!item.hasOwnProperty('Cost')) {
				this.snack('This product has no cost', 'error', false)
			} else {
				//set all the selected elements
				this.selected.product = item
				//IMPORTANT to note that anything that is a product name should be concat with a ' - ' and then the option 1 for that product
				this.selected.productSelect = this.selected.product['Product Name'] + ' - ' + this.selected.product['Option 1']
				this.selected.month = month
				//set the correct month name, have to subtract 1 from the selected month bc the array is 0-11 and not 1-12
				this.selected.monthSelect = this.monthNames[this.selected.month - 1]
				
				//get the actual qty for the item 
				let filteredActual = this.actualQtys.filter(item => item.Year == this.$props.year && item.Month == month && item.SKU == this.selected.product['Style Code'])
				let actualQty = filteredActual.reduce(function(sum,record) {return sum + record.Qty},0)
				//get the forecast qty for the item
				let filteredForecast = this.forecastQtys.filter(filteredItem => filteredItem.SKU == item['Style Code'] && filteredItem.Month == month && filteredItem.Biz_Dev !== 'Biz Dev')
				let forecastQty = filteredForecast.reduce(function(sum, record) {return sum + record.Qty},0)
				
				//set the qty as whichever one is higher
				if (forecastQty < actualQty) {
					item.Qty = Number(actualQty.toFixed(0))
					this.snack('The actual booked units was higher than the forecast', 'info',false)
				} else {
					item.Qty = Number(forecastQty.toFixed(0))
				}

				//set the minimum to be the actual qty for that month and sku
				this.qty.minimum = actualQty
				//set the input to be the products forecast
				this.qty.input = Number(this.selected.product.Qty.toFixed(0))
				//set the total to be the input
				this.qty.total = Number(this.qty.input.toFixed(0))
				
				//if right clicked or speed round enabled then follow here
				if (this.otherSettings.speedRound || simpleModal) {
					//turn off the menu
					this.modalState.simple = false
					//make sure the event was tracked because if the user scrolls
					//horizontally then the event is lost and e is undefined
					if(e) {
						//prevent traditionally right click behavior
						e.preventDefault()
						//set x and y coordinates
						this.x = e.clientX
						this.y = e.clientY
					}
					//turn on the simple menu
					this.modalState.simple = true
				} else {
					//if it is not speed round or not right clicked then set normal modal to true
					this.modalState.product = true
					//reset chart explain to false
					this.chart.explain = false
					//calculate the preorder asap split
					let preorderFilter = this.forecastQtys.filter( item => 
						item.Month == this.selected.month &&
						item.SKU == this.selected.product['Style Code'] &&
						item.Type == "Preorder")
					this.qty.preorder = preorderFilter.reduce(function(sum, record) { return sum + record.Qty }, 0)
					
					//gets the discount assigned with this month and product
					let discountFilter = this.forecastQtys.filter(item => 
						item.Month == this.selected.month && 
						item.SKU == this.selected.product['Style Code'])
					let discountMap = discountFilter.map(item => item.Discount_Percent)
					let discount = Math.max(...discountMap)
					if (discount != 0 && Number.isFinite(discount) ) {
						//sets the message underneath the preorder dicount field
						this.preorderDiscountMessage = 'From Settings<br>Prev Forecast was ' + Number(discount) * 100 + '%'
					} else {
						//sets the message underneath the preorder dicount field
						this.preorderDiscountMessage = 'From Settings'
					}

					//always prioritize the discount that is set in settings
					this.preorderDiscount = this.preorderDetails.discount

					//get the notes for this product and month
					this.getNotes()
					//if this is a biz dev month then call the biz dev function
					//else set the bizDev qty to 0
					if (this.BizDevMonth) {
						this.BizDevInformation()
					} else {
						this.qty.bizDev = 0
					}
					//calculate the dataset for the chart
					this.calculatedDataset()
				}
			}
		},
		simpleForecastChange() {
			//called when speed round is on
			this.qty.total = Number(this.qty.input)
		},
		monthChange(change) {
			if (this.qty.input != this.selected.product.Qty && this.otherSettings.saveOnMonthChange) {
				this.save(false)
			}
			let month = 0
			if (!change) {
				month = this.monthNames.indexOf(this.selected.monthSelect) + 1
			} else {
				this.selected.month += change
				month = this.selected.month
				this.selected.monthSelect = this.monthNames[month - 1]
			}

			this.open(this.selected.product, month, false)
		},
		productChange(change) {
			if (!change) {
				let product = this.products.filter(item => item['Product Name'] + ' - ' + item['Option 1'] == this.selected.productSelect)
				this.selected.product = product[0]
			} else {
				let position = this.productNames.indexOf(this.selected.product['Product Name'] + ' - ' + this.selected.product['Option 1'])
				product = this.products.filter(item => item['Product Name'] == this.productNames[position + change])
				this.selected.product = product[0]
			}

			this.open(this.selected.product,this.selected.month,false)
		},
		BizDevInformation() {
			let months = []
			let newDoors = 0
			if (this.selected.month == 2) {
				months = this.firstHalf
				newDoors = this.doors.firstHalfPrediction
			} else if (this.selected.month == 8) {
				months = this.secondHalf
				newDoors = this.doors.secondHalfPrediction
			}
			let year = this.$props.year - 1

			let bizDevQty = this.forecastQtys.filter(item => 
				item.Month == this.selected.month &&
				item.SKU == this.selected.product['Style Code'] &&
				item.Biz_Dev == 'Biz Dev')

			let filter = this.actualQtys.filter(item => 
				months.indexOf(item.Month) >= 0 && 
				item.Year == year &&
				item.SKU == this.selected.product['Style Code'])
			let qtyTotal = filter.reduce(function(sum,record) { return sum + record.Qty },0)

			let averagePerDoor = qtyTotal / this.doors.current
			let totalBizDevQty = 0
			console.log({bizDevQty});
			if (bizDevQty.length != 0) {
				totalBizDevQty = bizDevQty.reduce(function(sum,record) { return sum + record.Qty }, 0)
			} else {
				totalBizDevQty = Math.round(averagePerDoor * newDoors)
			}

			this.qty.bizDev = Math.round(totalBizDevQty)
			this.qty.total = Number(this.qty.bizDev) + Number(this.qty.input)

			this.bizDev.newDoors = newDoors
			this.bizDev.averagePerDoor = averagePerDoor.toLocaleString("en-US")
			this.bizDev.totalBizDevQty = Math.ceil(totalBizDevQty)
		},
		updateForecast(bizDev) {
			if(bizDev) {
				this.qty.preorder = this.qty.bizDev
			}
			if (this.qty.input == 0) {
				this.qty.preorder = 0
			}
			this.qty.total = Number(this.qty.bizDev) + Number(this.qty.input)
			let yearFilter = this.forecastQtys.filter(item => item.SKU == this.selected.product['Style Code'] && item.Month != this.selected.month)
			let yearTotal = yearFilter.reduce(function(sum,record) { return sum + record.Qty },0)
			yearTotal += this.qty.total

			let changedYear = this.chart.data.datasets.find(item => item.label.includes(this.$props.year + ' Forecast: '))
			changedYear.data[this.selected.month - 1] = Number(this.qty.total);
			changedYear.label = this.$props.year + ' Forecast: ' + Math.round(Number(yearTotal))
			this.chart.refresh += 1
		},
		getNotes() {
			this.productNotes = []
			for (let y = this.$props.year - 2; y <= this.$props.year; y++) {
				let note = this.notes.find(item => 
				item.Style_Code == this.selected.product['Style Code'] && 
				item.Month == this.selected.month &&
				item.Year == y)
				if (note == undefined || note === '') {
					this.productNotes.push('No Notes')
				} else {
					if (note.Notes == null || note.Notes === '') {
						this.productNotes.push('No Notes')
					} else {
						this.productNotes.push(note.Notes)
					}
				}
			}
			if (this.productNotes[2] === 'No Notes') {
				this.selected.product.Notes = ''
			} else {
				this.selected.product.Notes = this.productNotes[2]
			}	
		},
		calculatedDataset() {
			this.chart.data.datasets = []
			let tempDataset = []
			let helper = {}
			let filterList = this.actualQtys.filter(item => item.SKU === this.selected.product["Style Code"])
			let result = filterList.reduce(function(r,o) {
				let key = o.Year + '-' + o.Month;

				if (!helper[key]) {
					helper[key] = Object.assign({}, o)
					r.push(helper[key])
				} else {
					helper[key].Qty += o.Qty
				}
				return r
			}, [])
			
			let chartYears = this.chartYears

			for (let i = 0; i < chartYears.length; i++) {
				let yearData = {
					label: chartYears[i].year.toString(),
					sku: this.selected.product['Style Code'],
					fill: false,
					borderColor: chartYears[i].color, 
					data: [],
				}
				if (!yearData.label.includes("Forecast")) {
					let year = chartYears[i].year
					let yearFilter = this.actualQtys.filter(item => 
						item.Year == year && 
						item.SKU == this.selected.product['Style Code'])
					let yearTotal = yearFilter.reduce(function(sum,record) {
						return sum + record.Qty
					},0)
					yearData.label = yearData.label + ': '+ yearTotal
					for (let m = 1; m <= 12; m++) {
						let monthQty = result.filter(item => item.Year == chartYears[i].year && item.Month == m)
						monthQty = monthQty.reduce(function(sum,record) { return sum + record.Qty },0)
						yearData.data.push(monthQty)
					}
				} else {
					let yearFilter = this.forecastQtys.filter(item => item.SKU == this.selected.product['Style Code'])
					let yearTotal = yearFilter.reduce(function(sum,record) { return sum + record.Qty },0)

					yearData.label = yearData.label + ': '+ Math.round(yearTotal)
					for (let m = 1; m <= 12; m++) {
						if (m == Number(this.selected.month)) {
							yearData.data.push(Number(this.qty.total))
						} else {
							let forecastQty = this.forecastQtys.filter(item => item.SKU == this.selected.product['Style Code'] && item.Month == m)
							forecastQty = forecastQty.reduce(function(sum, record) { return sum + record.Qty },0)
							yearData.data.push(Math.round(forecastQty))
						}
					}
				}
				tempDataset.push(yearData)
				//this.chart.data.datasets.push(yearData)
			}
			let tempData = {
				datasets: tempDataset,
				label: "Overview",
				labels: this.monthNames
			}
			this.chart.data = tempData
			//this.chart.data.datasets = tempDataset
		},
		toggleProductInChart() {
			this.calculatedDataset()
			if (this.selected.compare.product !== 'None Selected') {
				let year = this.selected.compare.year
				let data = []
				let total = 0
				let product = this.products.find(item => item['Product Name'] + ' - ' + item['Option 1'] == this.selected.compare.product)
				this.selected.compare.sku = product['Style Code']

				for (let m = 1; m <= 12; m++) {
					let filter = this.actualQtys.filter(item => item.Year == year && item.Month == m && item.SKU == product['Style Code'])
					let qty = filter.reduce(function(sum, record) {return sum + record.Qty},0)
					total += qty
					data.push(qty)
				}

				let altColor = this.chartYears.find(item => item.year == year).altColor

				let dataset = {
					data: data,
					sku: product['Style Code'],
					borderColor: altColor,
					fill: false,
					label: year + ': ' + product['Product Name'] + ' ' + product['Option 1'] + ': ' + total
				}
				this.chart.data.datasets.push(dataset)
				this.chart.refresh = (Number(this.chart.refresh) + 1).toString()
			} else {
				this.chart.refresh = (Number(this.chart.refresh) + 1).toString()
			}
		},
		rowColor(active) {
			if (active == 1) {
				return "#000000"
			} else if (active == 0) {
				return "#FB7373"
			}
		},
		returnActuals(month, sku, preorder){
			let html = ''
			
            if (!preorder) {
				let qtys = []
				let growths = []
				let averageGrowth = 0
                for (let i = this.$props.year - 2; i <= this.$props.year; i++) {
                    let qty = this.actualQtys.reduce(function(sum, record) {
                        if(record.Month == month && record.SKU == sku && record.Year == i) {
                            return sum + record.Qty;
                        } else {
                            return sum;
                        }
                    }, 0);
                    let total = this.actualQtys.reduce(function(sum, record) {
                        if(record.Month == month && record.SKU == sku && record.Year == i) {
                            return sum + record.Total;
                        } else {
                            return sum;
                        }
                    }, 0);
					qtys.push(qty)
                    html = "<strong>" + i + ": </strong>" + qty.toLocaleString("en-US") + "<br>" + formatter.format(total) + "<br>" + html
                }
				
                return html
            } else {
                for (let i = this.$props.year - 2; i <= this.$props.year; i++) {
                    let asapFilter = this.actualQtys.filter(item =>
						item.Month == month && 
						item.SKU == sku && 
						item.Year == i && 
						item.Order_Type == "ASAP")
					let preorderFilter = this.actualQtys.filter(item =>
						item.Month == month && 
						item.SKU == sku && 
						item.Year == i && 
						item.Order_Type == "Preorder")
					let qtyASAP = asapFilter.reduce(function(sum, record) {
						return sum + record.Qty
                    },0)
					let qtyPreorder = preorderFilter.reduce(function(sum, record) {
						return sum + record.Qty
                    },0)
					let totalASAP = asapFilter.reduce(function(sum, record) {
						return sum + record.Total
                    },0)
					let totalPreorder = preorderFilter.reduce(function(sum, record) {
						return sum + record.Total
                    },0)
                    html =  "<strong>" + i + ": </strong>" + 
                        qtyPreorder.toLocaleString("en-US") + " / " + qtyASAP.toLocaleString("en-US") + "<br>" +
                        formatter.format(totalPreorder) + " / " + formatter.format(totalASAP) + "<br>" + html
                }
                return html
            }
        },
        returnForecast(month, sku, preorder) {
            let html = ''
            if (!preorder) {
                let filtered = this.forecastQtys.filter(item => item.Month == month && item.SKU == sku)
                let qty = filtered.reduce(function(sum, record) { return sum + record.Qty },0)
				let total = filtered.reduce(function(sum, record) { return sum + record.Total },0)

				let actualQtyFilter = this.actualQtys.filter(item => item.Month == month && item.Year == this.$props.year - 1 && item.SKU == sku)
				let actualQty = actualQtyFilter.reduce(function(sum,record) { return sum + record.Qty },0)
				let growth = ((qty - actualQty) / actualQty * 100).toFixed(2)

				if (growth === "NaN") {
					growth = 0
				}
				html = qty.toLocaleString("en-US") + "<br>" + growth + "%" + "<br>" + formatter.format(total) 
            } else {
                let asapFiltered = this.forecastQtys.filter(item => item.Month == month && item.SKU == sku && item.Type == "ASAP")
				let asapQty = asapFiltered.reduce(function(sum, record) { return sum + record.Qty },0)
				let asapTotal = asapFiltered.reduce(function(sum, record) { return sum + record.Total },0)

				let asapActualFilter = this.actualQtys.filter(item => item.Month == month && item.SKU == sku && item.Year == this.$props.year - 1 && item.Type == "ASAP")
				let asapActualQty = asapActualFilter.reduce(function(sum,record) { return sum + record.Qty },0)
				let asapGrowth = ((asapQty - asapActualQty) / asapActualQty * 100).toFixed(2)

				if (asapGrowth === "NaN") {
					asapGrowth = 0
				}
				let preorderFiltered = this.forecastQtys.filter(item => item.Month == month && item.SKU == sku && item.Type == "Preorder")
				let preorderQty = preorderFiltered.reduce(function(sum, record) { return sum + record.Qty },0)
				let preorderTotal = preorderFiltered.reduce(function(sum, record) { return sum + record.Total },0)

				let preorderActualFilter = this.actualQtys.filter(item => item.Month == month && item.SKU == sku && item.Year == this.$props.year - 1 && item.Type == "Preorder")
				let preorderActualQty = preorderActualFilter.reduce(function(sum,record) { return sum + record.Qty },0)
				let preorderGrowth = ((preorderQty - preorderActualQty) / preorderActualQty * 100).toFixed(2)

				if (preorderGrowth === "NaN") {
					preorderGrowth = 0
				}
				html = preorderQty.toLocaleString("en-US") + ' / ' + asapQty.toLocaleString("en-US") + '<br>' + 
					preorderGrowth + '% / ' + asapGrowth + '%' + '<br>' +
					formatter.format(preorderTotal) + ' / ' + formatter.format(asapTotal) 
			}
            return html
        },
        historicalTotals(objectArray, preorder) {
            let html = '';
            if (!preorder) {
				let qtys = []
				let averageGrowth = 0
                for (let i = this.$props.year - 2; i <= this.$props.year; i++) {
					let filter = objectArray.filter(item => item.Year == i)
					let qty = filter.reduce(function(sum,record) {
						return sum + record.Qty
                    },0)
					qtys.push(qty)
                    let total = filter.reduce(function(sum, record) {
						return sum + record.Total
                    },0)
                    html = '<strong>' + i + ': </strong>' + qty.toFixed(0) + '<br>' + formatter.format(total) + '<br>' + html
                }
				let filteredQty = qtys.filter(item => item != 0)
				if (filteredQty.length == 3) {
					let growth1 = (filteredQty[1] - filteredQty[0]) / filteredQty[0]
					let growth2 = (filteredQty[2] - filteredQty[1]) / filteredQty[1]
					averageGrowth = ((growth1 + growth2) / 2 * 100).toFixed(2)
					html = html + "<strong>Growth: </strong>" + averageGrowth + '%'
				} else if (filteredQty.length == 2) { 
					averageGrowth = ((filteredQty[1] - filteredQty[0]) / filteredQty[0] * 100).toFixed(2)
					html = html + "<strong>Growth: </strong>" + averageGrowth + '%'
				} 
				
            } else {
                for (let i = this.$props.year - 2; i <= this.$props.year; i++) {
                    let asapFilter = objectArray.filter(item => item.Year == i && item.Order_Type == 'ASAP')
					let preorderFilter = objectArray.filter(item => item.Year == i && item.Order_Type == 'Preorder')

					let asapQty = asapFilter.reduce(function(sum, record) { return sum + record.Qty }, 0)
					let asapTotal = asapFilter.reduce(function(sum, record) { return sum + record.Total }, 0)

					let preorderQty = preorderFilter.reduce(function(sum, record) { return sum + record.Qty }, 0)
					let preorderTotal = preorderFilter.reduce(function(sum, record) { return sum + record.Total }, 0)
                    
                    html = '<strong>' + i + ': </strong>' + preorderQty.toFixed(0) + ' / ' + asapQty.toFixed(0) + '<br>' + formatter.format(preorderTotal) + ' / ' + formatter.format(asapTotal) + '<br>' + html
                }
            }
			return html
        },
        forecastMonthTotals(month, preorder) {
			if (!preorder) {
				let filtered = this.forecastQtys.filter(item => month.includes(item.Month))
				let total = filtered.reduce(function(sum,record){
					return sum + record.Total
				},0)
				let qty = filtered.reduce(function(sum,record) {
					return sum + record.Qty
				},0)
				let actualQtyFilter = this.actualQtys.filter(item => month.includes(item.Month) && item.Year == this.$props.year - 1)
				let actualQty = actualQtyFilter.reduce(function(sum,record) {
					return sum + record.Qty
				}, 0)
				let growth = ((qty - actualQty) / actualQty * 100).toFixed(2)
				if (growth === "NaN") {
					growth = 0
				}
				return qty.toLocaleString("en-US") + '<br>' + formatter.format(total) + '<br>' + growth + '%'
			} else {
				let asapFiltered = this.forecastQtys.filter(item => month.includes(item.Month) && item.Type == 'ASAP')
				let asapQty = asapFiltered.reduce(function(sum,record){ return sum + record.Qty },0)
				let asapTotal = asapFiltered.reduce(function(sum,record){ return sum + record.Total },0)

				let asapActualFilter = this.actualQtys.filter(item => item.Year == this.$props.year - 1 && month.includes(item.Month) && item.Type == 'ASAP')
				let asapActualQty = asapActualFilter.reduce(function(sum,record) { return sum + record.Qty },0)
				let asapGrowth = ((asapQty - asapActualQty) / asapActualQty * 100).toFixed(2)

				let preorderFiltered = this.forecastQtys.filter(item => month.includes(item.Month) && item.Type == 'Preorder')
				let preorderQty = preorderFiltered.reduce(function(sum,record){ return sum + record.Qty },0)
				let preorderTotal = preorderFiltered.reduce(function(sum,record){ return sum + record.Total },0)

				let preorderActualFilter = this.actualQtys.filter(item => item.Year == this.$props.year - 1 && month.includes(item.Month) && item.Type == 'Preorder')
				let preorderActualQty = preorderActualFilter.reduce(function(sum,record) { return sum + record.Qty },0)
				let preorderGrowth = ((preorderQty - preorderActualQty) / preorderActualQty * 100).toFixed(2)

				return preorderQty.toLocaleString("en-US") + ' / ' + asapQty.toLocaleString("en-US") + '<br>' + 
					formatter.format(preorderTotal) + ' / ' + formatter.format(asapTotal) + '<br>' +
					preorderGrowth + '% / ' + asapGrowth + '%'
			}
        },
        forecastSKUTotals(sku, preorder, half) {
			if (!preorder) {
				let filtered = this.forecastQtys.filter(item => item.SKU == sku && half.includes(item.Month))
				let total = filtered.reduce(function(sum,record){
					return sum + record.Total
				},0)
				let qty = filtered.reduce(function(sum,record) {
					return sum + record.Qty
				},0)
				let actualFiltered = this.actualQtys.filter(item => item.Year == this.$props.year - 1 && item.SKU == sku && half.includes(item.Month))
				let actualQty = actualFiltered.reduce(function(sum,record) {
					return sum + record.Qty
				},0)
				let growth = ((qty - actualQty) / actualQty * 100).toFixed(2)
				if (growth === "NaN") {
					growth = 0
				}
				return qty.toLocaleString("en-US") + '<br>' + 
					growth + '%' + '<br>' +
					formatter.format(total)

			} else {
				let asapFiltered = this.forecastQtys.filter(
						item => item.SKU == sku && 
						item.Type == 'ASAP' &&
						half.includes(item.Month))
				let asapQty = asapFiltered.reduce(function(sum,record){
					return sum + record.Qty
				},0)
				let asapTotal = asapFiltered.reduce(function(sum,record){
					return sum + record.Total
				},0)
				let asapActualFilter = this.actualQtys.filter(item => item.Year == this.$props.year - 1 && item.SKU == sku && item.Type == "ASAP")
				let asapActualQty = asapActualFilter.reduce(function(sum,record) {
					return sum + record.Qty
				},0)
				let asapGrowth = ((asapQty - asapActualQty) / asapActualQty * 100).toFixed(2)
				if (asapGrowth === "NaN") {
					asapGrowth = 0
				}
				let preorderFiltered = this.forecastQtys.filter(
					item => item.SKU == sku && 
					item.Type == 'Preorder' &&
					half.includes(item.Month))
				let preorderQty = preorderFiltered.reduce(function(sum,record){
					return sum + record.Qty
				},0)
				let preorderTotal = preorderFiltered.reduce(function(sum,record){
					return sum + record.Total
				},0)
				let preorderActualFilter = this.actualQtys.filter(item => item.Year == this.$props.year - 1 && item.SKU == sku && item.Type == "Preorder")
				let preorderActualQty = preorderActualFilter.reduce(function(sum,record) {
					return sum + record.Qty
				},0)
				let preorderGrowth = ((preorderQty - preorderActualQty) / preorderActualQty * 100).toFixed(2)
				if (preorderGrowth === "NaN") {
					preorderGrowth = 0
				}

				return preorderQty.toLocaleString("en-US") + ' / ' + asapQty.toLocaleString("en-US") + '<br>' + 
					formatter.format(preorderTotal) + ' / ' + formatter.format(asapTotal) + '<br>' +
					preorderGrowth + '% / ' + asapGrowth + '%'
			}
        },
        skuTotals(sku, preorder, half) {
            let filter = this.actualQtys.filter(item => item.SKU == sku && half.includes(item.Month))
            return this.historicalTotals(filter, preorder)
		},
        returnMonthTotals(column, preorder) {
            let html = ''
            //not preorders
			if (column.value == 'cost' || column.value == 'Product Name') {
				return '<strong>Totals</strong>'
			} else if (column.month.length > 0) {
				//historicals
				if (!column.forecast) {
					let html = ''
					if (!preorder) {
						for (let i = this.$props.year - 2; i <= this.$props.year; i++) {
							let filter = this.monthTotals.filter(item => column.month.includes(item.Month) && item.Year == i)

							let qty = filter.reduce(function(sum, record) { return sum + record.Qty },0)
							let total = filter.reduce(function(sum, record) { return sum + record.Total },0)

							html = i + ': ' + qty.toLocaleString('en-US') + '<br>' + formatter.format(total) + '<br>' + html
						}
					} else {
						for (let i = this.$props.year - 2; i <= this.$props.year; i++) {
							let asapFilter = this.monthTotals.filter(item => column.month.includes(item.Month) && item.Year == i && item.Order_Type == "ASAP")
							let preorderFilter = this.monthTotals.filter(item => column.month.includes(item.Month) && item.Year == i && item.Order_Type == "Preorder")

							let asapQty = asapFilter.reduce(function(sum, record) { return sum + record.Qty },0)
							let asapTotal = asapFilter.reduce(function(sum, record) { return sum + record.Total },0)
							let preorderQty = preorderFilter.reduce(function(sum, record) { return sum + record.Qty },0)
							let preorderTotal = preorderFilter.reduce(function(sum, record) { return sum + record.Total },0)

							html = i + ': ' + preorderQty.toLocaleString("en-US") + ' / ' + asapQty.toLocaleString("en-US") + '<br>' + formatter.format(preorderTotal) + ' / ' + formatter.format(asapTotal) + '<br>' + html
						}
					}
					return html
				//forecast
				} else {
					html = this.forecastMonthTotals(column.month, preorder)
				}
				return html
            } else {
                return ''
            }
        },
		snack(text, color, loading) {
			if (loading) {
				this.loading = true
				this.snackbar = true
				this.snackText = text
				this.snackColor = color
				this.timeout = -1
			} else {
				this.loading = false
				this.snackbar = true
				this.snackText = text
				this.snackColor = color
				this.timeout = 3000
			}
		},
		clickableItem(active) {
			if (active) {
				return "clickable"
			} else {
				return ""
			}
		}
	},
	computed: {
		otherSettings() {
			return this.$store.getters.getOtherSettings
		},
		preorderDetails() {
			return this.$store.getters.getPreorder
		},
		isThereAlreadyBizDevQty() {
			let bizDevFilter = this.forecastQtys.filter(item =>
				item.Month == this.selected.month &&
				item.SKU == this.selected.product['Style Code'] &&
				item.Biz_Dev == 'Biz Dev'
			)
			if (bizDevFilter.length != 0) {
				return true
			} else {
				return false
			}
		},
		returnMonthActuals() {
			let filter = this.actualQtys.filter(item => item.Year == this.$props.year && item.Month == this.selected.month && item.SKU == this.selected.product['Style Code'])
			return filter.reduce(function(sum, record) {
				return sum + record.Qty
			}, 0)
		},
		filteredTable() {
			if (this.warning.message.length > 0) {
				return []
			}

			let active = []
			if (this.otherSettings.hideInactiveProducts) {
				active = [1]
			} else {
				active = [0,1]
			}
			if (this.otherSettings.specificForecastProducts) {
				let forecastProductSKUs = this.forecastProducts.map(item => item.SKU)
				return this.products.filter(item => active.includes(item.Active) && forecastProductSKUs.includes(item['Style Code']))
			} else {
				return this.products.filter(item => active.includes(item.Active))
			}
			
		},
		BizDevMonth() {
			if (this.selected.month == 2 && this.doors.firstHalfPrediction > 0) {
				return true
			} else if (this.selected.month == 8 && this.doors.secondHalfPrediction > 0) {
				return true
			} else {
				return false
			}
		},
		dialogTitle() {
			if (this.BizDevMonth) {
				return "font-size: 14px"
			} else {
				return "font-size: 18px"
			}
		},
		sliderMinimum() {
			if (this.BizDevMonth) {
				return this.qty.bizDev
			} else {
				return this.qty.minimum || 0
			}
		},
		preorderTotal() {
			let qty = this.qty.preorder
			let price = this.selected.product.Price
			let discount = (Number(this.preorderDiscount) / 100)
			return (qty * price * (1 - discount)).toFixed(2)
		},
		asapTotal() {
			this.qty.asap = Number(this.qty.total) - Number(this.qty.preorder)
			let price = this.selected.product.Price
			return (this.qty.asap * price).toFixed(2)
		},
		lineTotal() {
			return Number(this.preorderTotal) + Number(this.asapTotal)
		},
		preorderBizDevTotal() {
			return Number(this.qty.bizDev) * Number(this.selected.product.Price) * (1 - (Number(this.preorderDiscount) / 100)).toFixed(2) || 0
		},
		preorderBizDevDiscountTotal() {
			return Number(this.qty.bizDev) * Number(this.selected.product.Price) * (Number(this.preorderDiscount) / 100).toFixed(2) || 0
		},
		preorderNormalTotal() {
			return (Number(this.qty.preorder) - Number(this.qty.bizDev)) * Number(this.selected.product.Price) * (1 - (Number(this.preorderDiscount) / 100)).toFixed(2) || 0
		},
		preorderNormalDiscountTotal() {
			return (Number(this.qty.preorder) - Number(this.qty.bizDev)) * Number(this.selected.product.Price) * (Number(this.preorderDiscount) / 100).toFixed(2) || 0
		},
		percentPreorder() {
			return Math.round(this.qty.preorder / this.qty.total * 100);
		},
		percentASAP() {
			return Math.round(this.qty.asap / this.qty.total * 100)
		},
		getYears() {
			let years = []
			for (let i = this.$props.year - 3; i <= this.$props.year; i++) {
				years.push(i)
			}
			return years
		},
		showPreOrders() {
			if (this.actualQtys.length>0 && this.preorderDetails.switch) {
				return true
			} else {
				return false;
			}
		},
		productNames() {
			let name = []
			for (let i = 0; i < this.products.length; i++) {
				name.push(this.products[i]['Product Name'] + ' - ' + this.products[i]['Option 1'])
			}
			return name
		},
		activeProductNames() {
			let name = []
			for (let i = 0; i < this.products.length; i++) {
				if (this.products[i].Active == 1) {
					name.push(this.products[i]['Product Name'] + ' - ' + this.products[i]['Option 1'])
				}
			}
			return name
		},
		showTotalRow() {
			if (this.otherSettings.showTotalRow) {
				return "sticky-table-footer footer-color"
			} else {
				return "footer-color"
			}
		},
		chartYears() {
			return [
				{
					year: this.$props.year - 3,
					color: "#19816B",
					altColor: "#75B3A6",
				},
				{
					year: this.$props.year - 2,
					color: "#FEB92B",
					altColor: "#FFDFA9",
				},
				{
					year: this.$props.year - 1,
					color: "#00729C",
					altColor: "#A1B6CE",
				},
				{
					year: this.$props.year,
					color: "#B41131",
					altColor: "#DA9D92",
				},
				{
					year: this.$props.year + ' Forecast',
					color: "#542A76"
				}
			]
		},
		compareProducts() {
			let products = this.productNames
			products.unshift('None Selected')
			return products
		},
		columnWidth() {
			if(this.preorderDetails.switch) {
				return '200px'
			} else {
				return '80px'
			}
		},
		headers() {
			return [
				{
					text: 'Product Name',
					align: 'start',
					value: 'Product Name',
					fixed: true,
					width: '300px',
                    month: [],
                    forecast: false,
				},
				{
					text: 'SKU',
					value: 'Style Code',
					fixed: true,
					width: '100px',
                    month: [],
                    forecast: false,
				},
				{
					text: this.selected.price + ' Price',
					value: 'price',
					fixed: true,
					width: '100px',
                    month: [],
                    forecast: false,
				},
				{
					text: this.selected.cost + ' Cost',
					value: 'cost',
					fixed: true,
					width: '100px',
                    month: [],
                    forecast: false,
				},
        		{
					text: 'Jan Hist',
					value: 'hist_1',
					width: this.columnWidth,
                    month: [1],
                    forecast: false,
				},
				{
					text: 'Jan',
					value: '1',
					width: this.columnWidth,
					align: 'center',
                    month: [1],
                    forecast: true,
				},
				{
					text: 'Feb Hist',
					value: 'hist_2',
          			width: this.columnWidth,
                    month: [2],
                    forecast: false,
				},
				{
					text: 'Feb',
					value: '2',
					width: this.columnWidth,
					align: 'center',
                    month: [2],
                    forecast: true,
				},
        		{
					text: 'Mar Hist',
					value: 'hist_3',
          			width: this.columnWidth,
                    month: [3],
                    forecast: false,
				},
				{
					text: 'Mar',
					value: '3',
					width: this.columnWidth,
					align: 'center',
                    month: [3],
                    forecast: true,
				},
        		{
					text: 'Apr Hist',
					value: 'hist_4',
          			width: this.columnWidth,
                    month: [4],
                    forecast: false,
				},
				{
					text: 'Apr',
					value: '4',
					width: this.columnWidth,
					align: 'center',
                    month: [4],
                    forecast: true,
				},
        		{
					text: 'May Hist',
					value: 'hist_5',
          			width: this.columnWidth,
                    month: [5],
                    forecast: false,
				},
				{
					text: 'May',
					value: '5',
					width: this.columnWidth,
					align: 'center',
                    month: [5],
                    forecast: true,
				},
        		{
					text: 'Jun Hist',
					value: 'hist_6',
          			width: this.columnWidth,
                    month: [6],
                    forecast: false,
				},
				{
					text: 'Jun',
					value: '6',
					width: this.columnWidth,
					align: 'center',
                    month: [6],
                    forecast: true,
				},
				{
					text: '1st Half Total',
					value: '1stHalfTotal',
					width: this.columnWidth,
					align: 'center',
                    month: [1,2,3,4,5,6],
                    forecast: false,
				},
				{
					text: '1st Half Forecast Total',
					value: '1stHalfForecastTotal',
					width: this.columnWidth,
					align: 'center',
                    month: [1,2,3,4,5,6],
                    forecast: true,
				},
        		{
					text: 'Jul Hist',
					value: 'hist_7',
          			width: this.columnWidth,
                    month: [7],
                    forecast: false,
				},
				{
					text: 'Jul',
					value: '7',
					width: this.columnWidth,
					align: 'center',
                    month: [7],
                    forecast: true,
				},
        		{
					text: 'Aug Hist',
					value: 'hist_8',
          			width: this.columnWidth,
                    month: [8],
                    forecast: false,
				},
				{
					text: 'Aug',
					value: '8',
					width: this.columnWidth,
					align: 'center',
                    month: [8],
                    forecast: true,
				},
        		{
					text: 'Sep Hist',
					value: 'hist_9',
          			width: this.columnWidth,
                    month: [9],
                    forecast: false,
				},
				{
					text: 'Sep',
					value: '9',
					width: this.columnWidth,
					align: 'center',
                    month: [9],
                    forecast: true,
				},
        		{
					text: 'Oct Hist',
					value: 'hist_10',
          			width: this.columnWidth,
                    month: [10],
                    forecast: false,
				},
				{
					text: 'Oct',
					value: '10',
					width: this.columnWidth,
					align: 'center',
                    month: [10],
                    forecast: true,
				},
        		{
					text: 'Nov Hist',
					value: 'hist_11',
          			width: this.columnWidth,
                    month: [11],
                    forecast: false,
				},
				{
					text: 'Nov',
					value: '11',
					width: this.columnWidth,
					align: 'center',
                    month: [11],
                    forecast: true,
				},
        		{
					text: 'Dec Hist',
					value: 'hist_12',
          			width: this.columnWidth,
                    month: [12],
                    forecast: false,
				},
				{
					text: 'Dec',
					value: '12',
					width: this.columnWidth,
					align: 'center',
                    month: [12],
                    forecast: true,
				},
				{
					text: '2nd Half Total',
					value: '2ndHalfTotal',
					width: this.columnWidth,
					align: 'center',
                    month: [7,8,9,10,11,12],
                    forecast: false,
				},
				{
					text: '2nd Half Forecast Total',
					value: '2ndHalfForecastTotal',
					width: this.columnWidth,
					align: 'center',
                    month: [7,8,9,10,11,12],
                    forecast: true,
				},
				{
					text: 'Grand Total',
					value: 'total',
					width: this.columnWidth,
					align: 'center',
                    month: [1,2,3,4,5,6,7,8,9,10,11,12],
                    forecast: false,
				},
				{
					text: 'Forecast Grand Total',
					value: 'forecastTotal',
					width: this.columnWidth,
					align: 'center',
                    month: [1,2,3,4,5,6,7,8,9,10,11,12],
                    forecast: true,
				},
			];
		},
	},
};
</script>
